let requestQueue = Promise.resolve();
let queueLength = 0;

function safeFetch(url) {
  queueLength++;

  requestQueue = requestQueue.then(async () => {
    try {
      if (queueLength > 10) {
        await new Promise(r => setTimeout(r, 500));
      }

      await new Promise(r => setTimeout(r, 300));

      let res = await fetch(url);

      if (res.status === 429) {
        await new Promise(r => setTimeout(r, 1000));
        res = await fetch(url);
      }

      return res;

    } finally {
      console.log("Queue length:", queueLength);

      queueLength--; // ✅ ALWAYS runs
    }
  });

  return requestQueue;
}



function getBeautifulImages(result, perItems = 0, beauty = true) {


  if(beauty){

    return result.filter(img => img.likes > 450 && img.downloads > 1000 && img.imageWidth > 2000)
      .map(img => ({
        ...img,
        score: img.likes * 2 + img.downloads * 0.5 + img.comments * 1.5
      }))
      .sort((a, b) => b.score - a.score)
      .slice(0, perItems);
  }else{
      return perItems > 0 ? result.slice(0, perItems) : result;
  }
}

export async function fetchCuratedExploreNextImages(query) {

  try {

    const pages = [1, 4, 7, 10];

    const requests = pages.map((page) => {

      return safeFetch(
        `https://pixabay.com/api/?key=45283300-eddb6d21a3d3d06f2a2381d7d&q=${encodeURIComponent(query)}&image_type=photo&page=${page}&per_page=20`
      ).then((res) => res.json());

    });

    const results =
      await Promise.all(requests);

    const allHits =
      results.flatMap(
        (result) => result?.hits || []
      );

    console.log(
      "Combined hits:",
      allHits
    );

    // 🔥 CURATE
    // const curatedImages = getBeautifulImages(allHits);
    const curatedImages = allHits;

    return curatedImages;

  } catch (err) {

    console.log(
      "curated fetch failed",
      err
    );

    return [];
  }
}